import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { AddSpace } from 'modules/common/interceptors/add-space';
import { IStock } from 'modules/inventory/warehouse/interfaces';

class StockService extends EntityApiService<IStock> {
  getStockByProductId = (productId?: string, config?: RequestConfig) => {
    if (!productId) return;
    return ApiClientService.get(this.getPath(`/${productId}/stock`), config);
  };

  setStockByProductId = (productId: string, params?: any, config?: RequestConfig) => {
    if (!productId) return;
    // `warehouseArea` is an optional ObjectId. The forms default it to '' which the
    // backend rejects (@IsMongoId runs on '' because @IsOptional only skips
    // null/undefined). Send null when unset so validation skips it.
    const payload = { ...params, warehouseArea: params?.warehouseArea || null };
    return ApiClientService.post(this.getPath(`/${productId}/stock`), AddSpace(payload, payload?.warehouse), config);
  };

  updateVisibility = (productId: string, stockId: string, params?: any, config?: RequestConfig) => {
    return ApiClientService.patch(this.getPath(`/${productId}/stock/${stockId}/visibility`), params, config);
  };

  getStockByProductIdAndStoreId = (productId: string, warehouseId: string, config?: RequestConfig) => {
    if (!productId || !warehouseId) return;
    return ApiClientService.get(this.getPath(`/${productId}/stock/${warehouseId}`), config);
  };

  updateWarehouseArea = (productId: string, warehouseId: string, warehouseArea: string | null) => {
    return ApiClientService.patch(this.getPath(`/${productId}/stock/${warehouseId}/warehouse-area`), { warehouseArea });
  };
}

export default new StockService('/ms-inventory/api/products');
